<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <h2 class="my-4 text-secondary">
          {{ $t('my-sigma.select-installations-tab.filters-title') }}
        </h2>
      </b-col>
      <b-col
        :md="showRegional ? 6 : 12"
        cols="12"
      >
        <b-form-group>
          <tag-options-input
            class="mb-3"
            :label="$t('entities.company')"
            :tag-label="'name'"
            :track-tag-by="'id'"
            :tags="companiesOptions"
            :selected-items.sync="selectedCompanies"
            :options-custom-label="$t('reports.filters.options.all-companies')"
            :is-required-field="isCompanyFieldRequired"
            :dropdown-direction="dropdownDirection"
            @update:selectedItems="onUpdateCompanies"
            @remove-item="onRemoveCompany"
          />
        </b-form-group>
      </b-col>
      <b-col
        v-if="showRegional"
        md="6"
        cols="12"
      >
        <b-form-group>
          <tag-options-input
            class="mb-3"
            :label="$t('entities.regional')"
            :tag-label="'name'"
            :track-tag-by="'id'"
            :tags="regionalOptions"
            :selected-items.sync="selectedRegional"
            :is-required-field="isRegionalFieldRequired"
            :options-custom-label="$t('reports.filters.options.all-regional')"
            :disabled="!(selectedCompanies || []).length"
            :loading="loadingRegional"
            :dropdown-direction="dropdownDirection"
          />
        </b-form-group>
      </b-col>
      </b-row>
      <b-row align-h="end">
      <b-col
        cols="12"
        md="6"
        lg="auto"
      >
        <b-button
          block
          variant="secondary"
          :disabled="loadingInstallations"
          @click="clearFilter()"
        > {{ $t('my-sigma.select-installations-tab.clear-filters') }}
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="6"
        lg="auto"
        class="mt-md-0 mt-3"
      >
        <s-loading-button
          :loading="loadingInstallations"
          block
          variant="primary"
          @click="search()"
          :disabled="!hasFilters"
        >
          {{ $t('my-sigma.select-installations-tab.search') }}
        </s-loading-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CompanyService from '@/domain/services/company';
import RegionalService from '@/domain/services/regional';
import LoadingMixin from '@/services/loadingMixin';
import TagOptionsInput from '@/components/inputs/TagOptionsInput';
import { mapArrayIds } from '@/services/arrayUtils';

export default {
  name: 'SelectInstallationsTabFilter',
  mixins: [LoadingMixin],
  props: {
    customCompanies: {
      type: Array,
      default: () => [],
    },
    customRegional: {
      type: Array,
      default: () => [],
    },
    showRegionalWhenEmpty: {
      type: Boolean,
      default: true,
    },
    loadingInstallations: {
      type: Boolean,
      default: false,
    },
    isCompanyFieldRequired: {
      type: Boolean,
      default: false,
    },
    dropdownDirection: {
      type: String,
      default: '',
    },
    isRegionalFieldRequired: {
      type: Boolean,
      default: false,
    },
  },
  components: { TagOptionsInput },
  data: () => ({
    selectedCompanies: [],
    selectedRegional: [],
    companies: [],
    regional: [],
    emptyRegional: false,
    userCompaniesHaveRegional: true,
    loadingRegional: false,
  }),
  computed: {
    companiesOptions() {
      return this.customCompanies.length ? this.customCompanies : this.companies;
    },
    regionalOptions() {
      return this.regional.length ? this.regional : this.customRegional;
    },
    showRegional() {
      return this.userCompaniesHaveRegional || this.showRegionalWhenEmpty;
    },
    filter() {
      const companies = mapArrayIds(this.selectedCompanies);
      const regional = mapArrayIds(this.selectedRegional);
      return {
        companiesIds: companies,
        regionalIds: regional,
      };
    },
    hasFilters() {
      const { companiesIds, regionalIds } = this.filter;
      return companiesIds.length || regionalIds.length;
    },
  },
  methods: {
    filterSelectedRegionalWithoutParentItems(event) {
      return this.selectedRegional.filter(({ company }) => (company.name !== event.name));
    },
    onRemoveCompany(event) {
      this.selectedRegional = this.filterSelectedRegionalWithoutParentItems(event);
    },
    onRemoveAllRegional() {
      this.selectedRegional = [];
    },
    getCompanies() {
      this.startLoading();
      CompanyService
        .getCompanies()
        .then((response) => {
          this.endLoading();
          this.companies = response;
        });
    },
    getRegional() {
      if (!(this.selectedCompanies || []).length) {
        this.onRemoveAllRegional();
        return;
      }

      this.loadingRegional = true;
      this.startLoading();
      const companiesIds = mapArrayIds(this.selectedCompanies);
      RegionalService
        .getRegional(companiesIds)
        .then((response) => {
          this.endLoading();
          this.regional = response;
        })
        .finally(() => {
          this.loadingRegional = false;
        });
    },
    checkUserCompaniesRegional() {
      const allUserCompaniesIds = (this.selectedCompanies || []).length
        ? mapArrayIds(this.selectedCompanies)
        : mapArrayIds(this.companies);
      RegionalService.getRegional(allUserCompaniesIds)
        .then((response) => {
          this.userCompaniesHaveRegional = !!(response || []).length;
          this.$emit('user-companies-have-regional', this.userCompaniesHaveRegional);
        });
    },
    onUpdateCompanies() {
      this.checkUserCompaniesRegional();
      this.getRegional();
    },
    search() {
      this.$emit('search-installations', this.filter);
    },
    clearFilter() {
      this.selectedCompanies = [];
      this.selectedRegional = [];
      this.search();
    },
  },
  created() {
    this.getCompanies();
  },
};
</script>
